// extracted by mini-css-extract-plugin
export default {"button":"ComposeButton_button__qZbjg","icon-svg":"ComposeButton_icon-svg__H8Eqi"};